// extracted by mini-css-extract-plugin
export default {"h3":"estilos_h3__qALlQ","span":"estilos_span__Nnxv3"};